import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('OpenEgsGuide').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
    paddingTop: '20px',
    paddingBottom: '10vh',
  },

  title: {
    color: theme.colors.text.primary,
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.l,
    fontWeight: 650,
    textAlign: 'center',
    padding: '0',
    margin: '0',
  },
  sub: {
    color: theme.colors.text.secondary,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.s,
    fontWeight: 550,
    textAlign: 'left',
    margin: '0',
    padding: '0 5%',
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'start',
    width: '90%',
    gap: '12px',
    h2: {
      color: theme.colors.text.primary,
      fontSize: theme.sizes.texts.fontSize.l,
      lineHeight: theme.sizes.texts.lineHeight.l,
      fontWeight: 650,
      textAlign: 'left',
      padding: '0',
      margin: '0',
    },
    p: {
      color: theme.colors.text.secondary,
      fontSize: theme.sizes.texts.fontSize.s,
      lineHeight: theme.sizes.texts.lineHeight.s,
      fontWeight: 550,
      margin: '0',
    },
    img: {
      width: '100%',
    },
  },
}))
